import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { ProjectCard } from "@/components/ProjectCard";
import { useSiteContent } from "@/context/SiteContentContext";

export default function Projects() {
  const { content } = useSiteContent();
  const c = content.projects_page;
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).finally(() => setLoading(false));
  }, []);

  const filters = [
    { value: "all", label: c.filter_all },
    { value: "devam_ediyor", label: c.filter_ongoing },
    { value: "tamamlandi", label: c.filter_completed },
  ];

  const visible = projects.filter((p) => (filter === "all" ? true : p.status === filter));

  return (
    <div data-testid="projects-page" className="pt-32 lg:pt-40 pb-24 bg-[var(--ivory)] min-h-screen">
      <section className="relative px-6 lg:px-12 mb-16 overflow-hidden">
        <div className="pointer-events-none absolute -top-20 -right-20 w-72 h-72 border border-[var(--gold)]/20 rounded-full" />
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <span className="eyebrow">{c.eyebrow}</span>
            <h1 className="font-serif-luxe text-5xl lg:text-6xl mt-4 text-[var(--navy)] leading-tight">
              {c.heading_line1} <span className="italic text-[var(--gold)]">{c.heading_italic}</span>
            </h1>
            <div className="gold-divider w-24 my-6" />
            <p className="max-w-2xl text-[var(--slate)] leading-relaxed font-light whitespace-pre-line">{c.body}</p>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-12 mb-12">
        <div className="max-w-7xl mx-auto flex flex-wrap gap-3">
          {filters.map((f) => (
            <button
              key={f.value}
              data-testid={`filter-${f.value}`}
              onClick={() => setFilter(f.value)}
              className={`px-6 py-3 text-xs tracking-[0.22em] uppercase border transition-all ${
                filter === f.value
                  ? "bg-[var(--navy)] text-[var(--ivory)] border-[var(--navy)]"
                  : "bg-transparent text-[var(--navy)] border-[var(--navy)]/30 hover:border-[var(--gold)] hover:text-[var(--gold)]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </section>

      <section className="px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 lg:gap-10">
          {loading && <div className="col-span-2 text-center text-[var(--slate)] py-20">{c.loading_text}</div>}
          {!loading && visible.length === 0 && <div className="col-span-2 text-center text-[var(--slate)] py-20">{c.empty_text}</div>}
          {visible.map((p, i) => (
            <Reveal key={p.id} delay={i * 80}>
              <ProjectCard project={p} variant="wide" />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
